$(document).ready(function () {
  vodlInitSelectReport();
});

function vodlInitSelectReport() {
  let vodlSelectReport = $('.vodl-select-report__select'),
    vodlCurrentReport = $('.vodl-select-report__current');

  vodlSelectReport.each(function () {
    let vodlSelectReportDropdown = $(this).find('.vodl-select-report__dropdown'),
      vodlSelectReportDropdownElement = $(this).find('.vodl-select-report__dropdown li'),
      vodlReportScrollBtn = $(this).find('.vodl-select-report__arrow-down'),
      endOfDDReport = false;

    /**
     * toggle dropdown on click
     */

    $(this).unbind('click');

    $(this).click(function () {
      if (vodlReportScrollBtn.data('clicked')) {
        vodlSelectReportDropdown.scrollTop(200 + vodlSelectReportDropdown.scrollTop());
        vodlReportScrollBtn.data('clicked', false);
      } else {
        $(this).toggleClass('vodl-select-report--show');
        if ($(this).hasClass('vodl-select-report--show') && endOfDDReport === false) {
          vodlReportScrollBtn.addClass('vodl-select-report__arrow-down--show');
        } else {
          vodlReportScrollBtn.removeClass('vodl-select-report__arrow-down--show');
        }
      }
    });

    /**
     * Hide big arrow at the end of the dropdown list.
     */
    vodlSelectReportDropdown.scroll(function () {
      if (vodlSelectReportDropdown[0].offsetHeight + vodlSelectReportDropdown[0].scrollTop >= vodlSelectReportDropdown[0].scrollHeight) {
        vodlReportScrollBtn.removeClass('vodl-select-region__arrow-down--show');
        endOfDDReport = true;
      } else {
        vodlReportScrollBtn.addClass('vodl-select-region__arrow-down--show');
        endOfDDReport = false;
      }
    });

    /**
     * search with getEventTarget for the selected list item
     * and transfer its text to all current region spans on the page
     */
    vodlSelectReportDropdownElement.click(function (event) {
      let target = vodlGetEventTarget(event),
        slug = $(this).attr('data-report-slug');

      vodlCurrentReport.each(function () {
        $(this).trigger('report');
        $(this)[0].innerHTML = target.innerText;
        this.setAttribute('data-report-slug', slug);
      });
    });

    vodlReportScrollBtn.click(function () {
      $(this).data('clicked', true);
    });

  });
}
